import { sb } from '../supabase.ts';

export async function renderClassControlPage(app: HTMLElement) {
  app.innerHTML = `
<style>
  .control-wrap { background: #f8fafc; min-height: 100vh; padding: 32px; }
  .card { background: #fff; border-radius: 12px; border: 1px solid #e2e8f0; box-shadow: 0 4px 6px -1px rgba(0,0,0,0.05); margin-bottom: 24px; padding: 24px; transition: transform 0.2s ease, box-shadow 0.2s ease; }
  .card:hover { transform: translateY(-2px); box-shadow: 0 10px 15px -3px rgba(0,0,0,0.1); }
  .card h2 { font-size: 18px; font-weight: 700; color: #1e293b; margin-bottom: 20px; display: flex; align-items: center; gap: 8px; }
  
  .form-grid { display: grid; grid-template-columns: repeat(auto-fit, minmax(200px, 1fr)); gap: 16px; }
  .form-group { display: flex; flex-direction: column; gap: 6px; }
  .form-group label { font-size: 12px; font-weight: 600; color: #64748b; text-transform: uppercase; }
  .form-group select, .form-group input { padding: 10px; border: 1px solid #cbd5e1; border-radius: 8px; font-size: 14px; transition: border-color 0.2s, box-shadow 0.2s; }
  .form-group select:focus, .form-group input:focus { outline: none; border-color: var(--primary, #0061f2); box-shadow: 0 0 0 3px rgba(0, 97, 242, 0.15); }
  
  .btn-save { background: var(--primary, #0061f2); color: #fff; border: none; padding: 10px 24px; border-radius: 8px; font-weight: 600; cursor: pointer; margin-top: 16px; transition: background 0.2s, transform 0.1s; }
  .btn-save:hover { background: #0052cc; }
  .btn-save:active { transform: scale(0.98); }

  .btn-cancel { background: #64748b; color: #fff; border: none; padding: 10px 24px; border-radius: 8px; font-weight: 600; cursor: pointer; margin-top: 16px; transition: background 0.2s, transform 0.1s; }
  .btn-cancel:hover { background: #475569; }
  .btn-cancel:active { transform: scale(0.98); }

  .table-container { margin-top: 24px; }
  table { width: 100%; border-collapse: collapse; }
  th { text-align: left; padding: 12px; border-bottom: 2px solid #e2e8f0; color: #475569; font-size: 12px; }
  td { padding: 12px; border-bottom: 1px solid #f1f5f9; font-size: 14px; }
  tr:hover td { background-color: #f8fafc; }
  
  .action-btns { display: flex; gap: 8px; }
  .btn-edit { color: var(--primary, #0061f2); background: none; border: 1px solid #cbd5e1; padding: 4px 8px; border-radius: 4px; cursor: pointer; font-size: 12px; transition: background 0.2s, border-color 0.2s; }
  .btn-edit:hover { background: #f1f5f9; border-color: var(--primary, #0061f2); }
  .btn-del { color: #ef4444; background: none; border: 1px solid #fee2e2; padding: 4px 8px; border-radius: 4px; cursor: pointer; font-size: 12px; transition: background 0.2s; }
  .btn-del:hover { background: #fee2e2; }

  #msgBox, #modalMsgBox { margin-top: 12px; font-size: 14px; display: none; padding: 8px 12px; border-radius: 6px; }
  #msgBox.success, #modalMsgBox.success { background: #f0fdf4; border: 1px solid #bbf7d0; color: #166534; display: block; }
  #msgBox.error, #modalMsgBox.error { background: #fef2f2; border: 1px solid #fca5a5; color: #991b1b; display: block; }

  /* Modal Styles */
  .modal {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(15, 23, 42, 0.4);
    backdrop-filter: blur(8px);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 9999;
    opacity: 0;
    pointer-events: none;
    transition: opacity 0.3s ease;
  }
  .modal.active {
    opacity: 1;
    pointer-events: auto;
  }
  .modal-content {
    width: 100%;
    max-width: 480px;
    background: #fff;
    border-radius: 16px;
    padding: 32px !important;
    box-shadow: 0 20px 25px -5px rgba(0,0,0,0.1), 0 10px 10px -5px rgba(0,0,0,0.04);
    transform: scale(0.95);
    transition: transform 0.3s cubic-bezier(0.34, 1.56, 0.64, 1);
  }
  .modal.active .modal-content {
    transform: scale(1);
  }
  .modal-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 24px;
  }
  .modal-header h2 {
    margin-bottom: 0 !important;
  }
  .btn-close {
    background: none;
    border: none;
    font-size: 24px;
    color: #64748b;
    cursor: pointer;
    line-height: 1;
    padding: 4px;
    transition: color 0.2s;
  }
  .btn-close:hover {
    color: #1e293b;
  }
  
  .unassigned-badge {
    background: #fff1f2;
    color: #e11d48;
    border: 1px solid #ffe4e6;
    padding: 6px 14px;
    border-radius: 9999px;
    font-size: 13px;
    font-weight: 600;
    display: inline-flex;
    align-items: center;
    gap: 6px;
    box-shadow: 0 1px 2px rgba(0,0,0,0.05);
    transition: all 0.2s ease;
  }
  .unassigned-badge:hover {
    transform: translateY(-1px);
    box-shadow: 0 4px 6px -1px rgba(225, 29, 72, 0.1), 0 2px 4px -1px rgba(225, 29, 72, 0.06);
    background: #ffe4e6;
  }
</style>

<div class="control-wrap">
  <div class="container">
    <div id="unassignedWrap" class="card" style="display: none; border-left: 4px solid #e11d48;">
      <h2 style="color: #e11d48; margin-bottom: 8px; display: flex; align-items: center; gap: 8px;">
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" style="color: #e11d48;"><path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z"/><line x1="12" y1="9" x2="12" y2="13"/><line x1="12" y1="17" x2="12.01" y2="17"/></svg>
        Unassigned Class-Sections (কোনো শিক্ষক দায়িত্ব পাননি)
      </h2>
      <p style="font-size: 13px; color: #64748b; margin-top: -4px; margin-bottom: 16px;">
        The following class-section combinations do not have any teacher assigned to them yet:
      </p>
      <div id="unassignedList" style="display: flex; gap: 8px; flex-wrap: wrap;"></div>
    </div>

    <div class="card">
      <h2>Add Teacher Access Control</h2>
      <form id="accessForm">
        <div class="form-grid">
          <div class="form-group">
            <label>Teacher Name</label>
            <select id="teacherSelect" name="iid" required>
              <option value="">--Select Teacher--</option>
            </select>
          </div>
          <div class="form-group">
            <label>Teacher Email</label>
            <input type="email" id="teacherEmail" name="teacher_email" readonly placeholder="Auto-filled">
          </div>
          <div class="form-group">
            <label>Class Access</label>
            <select name="access_class" id="classSelect">
              <option value="">--All Classes--</option>
            </select>
          </div>
          <div class="form-group" id="sectionGroup" style="display: none;">
            <label>Section Access</label>
            <select name="access_section" id="sectionSelect">
              <option value="">--All Sections--</option>
            </select>
          </div>
        </div>
        <div id="msgBox"></div>
        <div style="display: flex; align-items: center; gap: 8px;">
          <button type="submit" id="submitBtn" class="btn-save">Save Access Record</button>
        </div>
      </form>
    </div>

    <div class="card">
      <h2>Existing Access Privileges</h2>
      <div class="table-container">
        <table>
          <thead>
            <tr>
              <th>Teacher</th>
              <th>Email</th>
              <th>Class</th>
              <th>Section</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody id="accessTbody">
            <tr><td colspan="5" style="text-align:center; padding:20px;">Loading access data...</td></tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</div>

<!-- Edit Access Modal -->
<div id="editModal" class="modal">
  <div class="modal-content card">
    <div class="modal-header">
      <h2>Edit Access Privileges</h2>
      <button class="btn-close" onclick="window.closeEditModal()">&times;</button>
    </div>
    <form id="editForm">
      <div class="form-grid" style="grid-template-columns: 1fr; gap: 16px;">
        <div class="form-group">
          <label>Teacher Name</label>
          <select id="modalTeacherSelect" name="iid" required>
            <option value="">--Select Teacher--</option>
          </select>
        </div>
        <div class="form-group">
          <label>Teacher Email</label>
          <input type="email" id="modalTeacherEmail" name="teacher_email" readonly placeholder="Auto-filled">
        </div>
        <div class="form-group">
          <label>Class Access</label>
          <select name="access_class" id="modalClassSelect">
            <option value="">--All Classes--</option>
          </select>
        </div>
        <div class="form-group" id="modalSectionGroup" style="display: none;">
          <label>Section Access</label>
          <select name="access_section" id="modalSectionSelect">
            <option value="">--All Sections--</option>
          </select>
        </div>
      </div>
      <div id="modalMsgBox"></div>
      <div style="display: flex; justify-content: flex-end; gap: 8px; margin-top: 24px;">
        <button type="button" class="btn-cancel" onclick="window.closeEditModal()" style="margin-top: 0;">Cancel</button>
        <button type="submit" id="modalSubmitBtn" class="btn-save" style="margin-top: 0;">Update Access</button>
      </div>
    </form>
  </div>
</div>
  `;

  const teacherSelect = document.getElementById('teacherSelect') as HTMLSelectElement;
  const teacherEmail = document.getElementById('teacherEmail') as HTMLInputElement;
  const classSelect = document.getElementById('classSelect') as HTMLSelectElement;
  const sectionSelect = document.getElementById('sectionSelect') as HTMLSelectElement;
  const accessForm = document.getElementById('accessForm') as HTMLFormElement;
  const accessTbody = document.getElementById('accessTbody')!;
  const msgBox = document.getElementById('msgBox')!;

  // Modal elements
  const editModal = document.getElementById('editModal') as HTMLElement;
  const editForm = document.getElementById('editForm') as HTMLFormElement;
  const modalTeacherSelect = document.getElementById('modalTeacherSelect') as HTMLSelectElement;
  const modalTeacherEmail = document.getElementById('modalTeacherEmail') as HTMLInputElement;
  const modalClassSelect = document.getElementById('modalClassSelect') as HTMLSelectElement;
  const modalSectionSelect = document.getElementById('modalSectionSelect') as HTMLSelectElement;
  const modalMsgBox = document.getElementById('modalMsgBox')!;

  const unassignedWrap = document.getElementById('unassignedWrap')!;
  const unassignedList = document.getElementById('unassignedList')!;
  let allClassSectionPairs: { cls: number; sec: string }[] = [];

  function populateSectionsForClass(clsVal: string, selectEl: HTMLSelectElement) {
    selectEl.innerHTML = '<option value="">--All Sections--</option>';
    if (!clsVal) return;
    const clsNum = Number(clsVal);
    const sectionsForClass = allClassSectionPairs
      .filter(pair => pair.cls === clsNum)
      .map(pair => pair.sec)
      .filter(Boolean);
    const uniqueSecs = [...new Set(sectionsForClass)].sort();
    uniqueSecs.forEach(sec => {
      const opt = document.createElement('option');
      opt.value = sec;
      opt.textContent = sec;
      selectEl.appendChild(opt);
    });
  }

  let currentAccessRecords: any[] = [];
  let editingTeacherIid: number | null = null;
  let editingIndex: number | null = null;
  let teachers: any[] = [];

  // Load teachers into both main select and modal select
  const { data: teachersData } = await sb.from('teacher_database').select('iid, teacher_name_en, teacher_email_id, access_class, access_section').order('teacher_name_en');
  if (teachersData) {
    teachers = teachersData;
    teachers.forEach(t => {
      // Main select
      const opt = document.createElement('option');
      opt.value = t.iid.toString();
      opt.textContent = t.teacher_name_en;
      opt.dataset.email = t.teacher_email_id || '';
      teacherSelect.appendChild(opt);

      // Modal select
      const modalOpt = document.createElement('option');
      modalOpt.value = t.iid.toString();
      modalOpt.textContent = t.teacher_name_en;
      modalOpt.dataset.email = t.teacher_email_id || '';
      modalTeacherSelect.appendChild(modalOpt);
    });
  }

  teacherSelect.onchange = () => {
    const opt = teacherSelect.selectedOptions[0];
    teacherEmail.value = opt ? (opt.dataset.email || '') : '';
  };

  modalTeacherSelect.onchange = () => {
    const opt = modalTeacherSelect.selectedOptions[0];
    modalTeacherEmail.value = opt ? (opt.dataset.email || '') : '';
  };

  classSelect.onchange = () => {
    const sectionGroup = document.getElementById('sectionGroup')!;
    if (classSelect.value) {
      populateSectionsForClass(classSelect.value, sectionSelect);
      sectionGroup.style.display = 'flex';
    } else {
      sectionGroup.style.display = 'none';
      sectionSelect.value = '';
      populateSectionsForClass('', sectionSelect);
    }
  };

  modalClassSelect.onchange = () => {
    const modalSectionGroup = document.getElementById('modalSectionGroup')!;
    if (modalClassSelect.value) {
      populateSectionsForClass(modalClassSelect.value, modalSectionSelect);
      modalSectionGroup.style.display = 'flex';
    } else {
      modalSectionGroup.style.display = 'none';
      modalSectionSelect.value = '';
      populateSectionsForClass('', modalSectionSelect);
    }
  };

  // Load dynamic classes and sections from student_database
  try {
    const { data: studentPairs } = await sb
      .from('student_database')
      .select('active_class, active_section')
      .not('active_class', 'is', null);

    const seenPairs = new Set<string>();
    const classesSet = new Set<number>();
    const sectionsSet = new Set<string>();

    allClassSectionPairs = [];

    if (studentPairs) {
      studentPairs.forEach(row => {
        const c = Number(row.active_class);
        const s = row.active_section;

        classesSet.add(c);
        if (s) {
          sectionsSet.add(s);
          const key = `${c}-${s}`;
          if (!seenPairs.has(key)) {
            seenPairs.add(key);
            allClassSectionPairs.push({ cls: c, sec: s });
          }
        }
      });
    }

    allClassSectionPairs.sort((a, b) => a.cls - b.cls || a.sec.localeCompare(b.sec));
    const uniqueClasses = [...classesSet].sort((a, b) => a - b);

    uniqueClasses.forEach(cls => {
      // Main select
      const opt = document.createElement('option');
      opt.value = cls.toString();
      opt.textContent = `Class ${cls}`;
      classSelect.appendChild(opt);

      // Modal select
      const modalOpt = document.createElement('option');
      modalOpt.value = cls.toString();
      modalOpt.textContent = `Class ${cls}`;
      modalClassSelect.appendChild(modalOpt);
    });
    updateUnassignedClassSections();
  } catch (err) {
    console.error('Failed to load dynamic classes and sections:', err);
  }

  async function loadAccessList() {
    const { data: teachersData, error } = await sb
      .from('teacher_database')
      .select('iid, teacher_name_en, teacher_email_id, access_class, access_section')
      .order('teacher_name_en');

    if (error) {
      accessTbody.innerHTML = '<tr><td colspan="5">Error loading data.</td></tr>';
      return;
    }

    teachers = teachersData || [];

    const flatRecords: any[] = [];
    teachers.forEach(t => {
      const classes = Array.isArray(t.access_class) ? t.access_class : [];
      const sections = Array.isArray(t.access_section) ? t.access_section : [];
      const length = Math.max(classes.length, sections.length);
      for (let i = 0; i < length; i++) {
        flatRecords.push({
          iid: t.iid,
          teacher_name_en: t.teacher_name_en,
          teacher_email: t.teacher_email_id,
          access_class: (classes[i] !== undefined && classes[i] !== null && classes[i] !== "") ? parseInt(classes[i]) : null,
          access_section: (sections[i] !== undefined && sections[i] !== null && sections[i] !== "") ? sections[i] : null,
          index: i
        });
      }
    });

    // Sort flatRecords by Class (ascending), then by Section (alphabetical)
    flatRecords.sort((a, b) => {
      const valA = a.access_class === null ? 0 : Number(a.access_class);
      const valB = b.access_class === null ? 0 : Number(b.access_class);
      if (valA !== valB) return valA - valB;
      
      const secA = a.access_section || '';
      const secB = b.access_section || '';
      return secA.localeCompare(secB);
    });

    currentAccessRecords = flatRecords;

    updateUnassignedClassSections();

    if (currentAccessRecords.length === 0) {
      accessTbody.innerHTML = '<tr><td colspan="5" style="text-align:center; padding:20px;">No access records found.</td></tr>';
      return;
    }

    accessTbody.innerHTML = currentAccessRecords.map(row => {
      const isProtectedEmail = row.teacher_email && row.teacher_email.toLowerCase() === 'gopalsdiary@gmail.com';
      const deleteBtnHtml = isProtectedEmail 
        ? '' 
        : `<button class="btn-del" onclick="window.deleteAccess(${row.iid}, ${row.index})">Delete</button>`;
      return `
        <tr>
          <td>${row.teacher_name_en}</td>
          <td>${row.teacher_email || 'N/A'}</td>
          <td>${row.access_class || '—'}</td>
          <td>${row.access_section || '—'}</td>
          <td>
            <div class="action-btns">
              <button class="btn-edit" onclick="window.editAccess(${row.iid}, ${row.index})">Edit</button>
              ${deleteBtnHtml}
            </div>
          </td>
        </tr>
      `;
    }).join('');
  }

  function updateUnassignedClassSections() {
    if (allClassSectionPairs.length === 0) {
      unassignedWrap.style.display = 'none';
      return;
    }

    const unassigned = allClassSectionPairs.filter(pair => {
      return !currentAccessRecords.some(r => {
        // Teacher has general access if no class is specified (All Classes)
        const hasGeneralClassAccess = !r.access_class;
        
        // Teacher has general access if no section is specified (All Sections of that class)
        const hasGeneralSectionAccess = !r.access_section;

        const matchClass = hasGeneralClassAccess || Number(r.access_class) === pair.cls;
        const matchSection = hasGeneralSectionAccess || r.access_section === pair.sec;

        return matchClass && matchSection;
      });
    });

    if (unassigned.length === 0) {
      unassignedWrap.style.display = 'none';
    } else {
      unassignedWrap.style.display = 'block';
      unassignedList.innerHTML = unassigned.map(pair => `
        <span class="unassigned-badge">
          <span style="display: inline-block; width: 6px; height: 6px; background-color: #e11d48; border-radius: 50%;"></span>
          Class ${pair.cls} — ${pair.sec}
        </span>
      `).join('');
    }
  }

  (window as any).closeEditModal = () => {
    editModal.classList.remove('active');
    editForm.reset();
    document.getElementById('modalSectionGroup')!.style.display = 'none';
    modalMsgBox.textContent = '';
    modalMsgBox.className = '';
    editingTeacherIid = null;
    editingIndex = null;
  };

  editModal.addEventListener('click', (e) => {
    if (e.target === editModal) {
      (window as any).closeEditModal();
    }
  });

  (window as any).editAccess = (iid: number, index: number) => {
    const row = currentAccessRecords.find(r => r.iid === iid && r.index === index);
    if (!row) return;

    editingTeacherIid = iid;
    editingIndex = index;

    // Set modal form values
    modalTeacherSelect.value = row.iid ? row.iid.toString() : '';
    modalTeacherEmail.value = row.teacher_email || '';
    modalClassSelect.value = row.access_class ? row.access_class.toString() : '';

    // Dynamically populate sections first, then set value
    if (row.access_class) {
      populateSectionsForClass(row.access_class.toString(), modalSectionSelect);
      modalSectionSelect.value = row.access_section || '';
    } else {
      populateSectionsForClass('', modalSectionSelect);
    }

    // Show/hide section based on class selection
    const modalSectionGroup = document.getElementById('modalSectionGroup')!;
    if (row.access_class) {
      modalSectionGroup.style.display = 'flex';
    } else {
      modalSectionGroup.style.display = 'none';
    }

    // Show modal
    editModal.classList.add('active');
  };

  accessForm.onsubmit = async (e) => {
    e.preventDefault();
    const formData = new FormData(accessForm);
    const data: any = Object.fromEntries(formData);
    
    // Convert types
    if (data.access_class) {
      data.access_class = parseInt(data.access_class as string);
    } else {
      data.access_class = null;
    }

    if (data.access_section === '') {
      data.access_section = null;
    }

    if (data.iid) {
      data.iid = parseFloat(data.iid as string);
    }

    const targetTeacher = teachers.find(t => Number(t.iid) === Number(data.iid));
    if (!targetTeacher) {
      msgBox.textContent = 'Error: Teacher not found';
      msgBox.className = 'error';
      return;
    }
    const currentClass = Array.isArray(targetTeacher.access_class) ? [...targetTeacher.access_class] : [];
    const currentSection = Array.isArray(targetTeacher.access_section) ? [...targetTeacher.access_section] : [];

    currentClass.push(data.access_class !== null ? data.access_class.toString() : "");
    currentSection.push(data.access_section || "");

    const { error } = await sb.from('teacher_database')
      .update({
        access_class: currentClass,
        access_section: currentSection
      })
      .eq('iid', targetTeacher.iid);

    if (error) {
      msgBox.textContent = 'Error: ' + error.message;
      msgBox.className = 'error';
    } else {
      msgBox.textContent = 'Access granted successfully!';
      msgBox.className = 'success';
      accessForm.reset();
      document.getElementById('sectionGroup')!.style.display = 'none';
      await loadAccessList();
    }
  };

  editForm.onsubmit = async (e) => {
    e.preventDefault();
    const formData = new FormData(editForm);
    const data: any = Object.fromEntries(formData);

    // Convert types
    if (data.access_class) {
      data.access_class = parseInt(data.access_class as string);
    } else {
      data.access_class = null;
    }

    if (data.access_section === '') {
      data.access_section = null;
    }

    if (data.iid) {
      data.iid = parseFloat(data.iid as string);
    }

    if (editingTeacherIid !== null && editingIndex !== null) {
      const targetTeacher = teachers.find(t => Number(t.iid) === Number(editingTeacherIid));
      if (!targetTeacher) {
        modalMsgBox.textContent = 'Error: Teacher not found';
        modalMsgBox.className = 'error';
        return;
      }
      const currentClass = Array.isArray(targetTeacher.access_class) ? [...targetTeacher.access_class] : [];
      const currentSection = Array.isArray(targetTeacher.access_section) ? [...targetTeacher.access_section] : [];

      if (editingIndex >= 0 && editingIndex < Math.max(currentClass.length, currentSection.length)) {
        while (currentClass.length <= editingIndex) currentClass.push("");
        while (currentSection.length <= editingIndex) currentSection.push("");

        currentClass[editingIndex] = data.access_class !== null ? data.access_class.toString() : "";
        currentSection[editingIndex] = data.access_section || "";
      }

      const { error } = await sb.from('teacher_database')
        .update({
          access_class: currentClass,
          access_section: currentSection
        })
        .eq('iid', editingTeacherIid);

      if (error) {
        modalMsgBox.textContent = 'Error: ' + error.message;
        modalMsgBox.className = 'error';
      } else {
        modalMsgBox.textContent = 'Access record updated successfully!';
        modalMsgBox.className = 'success';
        setTimeout(() => {
          (window as any).closeEditModal();
          loadAccessList();
        }, 800);
      }
    }
  };

  (window as any).deleteAccess = async (iid: number, index: number) => {
    const row = currentAccessRecords.find(r => r.iid === iid && r.index === index);
    if (row && row.teacher_email && row.teacher_email.toLowerCase() === 'gopalsdiary@gmail.com') {
      alert('This primary administrator account cannot be deleted!');
      return;
    }
    if (!confirm('Are you sure you want to revoke this access?')) return;

    const targetTeacher = teachers.find(t => Number(t.iid) === Number(iid));
    if (!targetTeacher) {
      alert('Error: Teacher not found');
      return;
    }
    const currentClass = Array.isArray(targetTeacher.access_class) ? [...targetTeacher.access_class] : [];
    const currentSection = Array.isArray(targetTeacher.access_section) ? [...targetTeacher.access_section] : [];

    currentClass.splice(index, 1);
    currentSection.splice(index, 1);

    const { error } = await sb.from('teacher_database')
      .update({
        access_class: currentClass,
        access_section: currentSection
      })
      .eq('iid', iid);

    if (error) alert('Error deleting: ' + error.message);
    else await loadAccessList();
  };

  loadAccessList();
}
